import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteLeft, FaStore, FaMobileAlt, FaUsers, FaChartLine, FaTruck, FaClipboardList, FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';
import styles from './Simao.module.css';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const Simao = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const images = [
    '/image.png',
    '/image.png',
    '/image.png',
    '/image.png',
    '/image.png'
  ];

  const testimonials = [
    {
      name: "Carlos Silva",
      business: "Restaurante Sabor & Arte",
      rating: 5,
      comment: "O Simão revolucionou nosso atendimento! Reduzimos o tempo de espera em 40% e aumentamos as vendas em 25% no primeiro mês.",
      date: "Dezembro 2024"
    },
    {
      name: "Ana Costa",
      business: "Pizzaria Bella Italia",
      rating: 5,
      comment: "Sistema intuitivo e completo. Nossos garçons adoraram a facilidade de uso e os clientes elogiam a agilidade no atendimento.",
      date: "Novembro 2024"
    },
    {
      name: "Roberto Mendes",
      business: "Hamburgueria Rock'n'Roll",
      rating: 5,
      comment: "Integração perfeita com delivery e gestão de pedidos impecável. Vale cada centavo do investimento!",
      date: "Outubro 2024"
    },
    {
      name: "Maria Oliveira",
      business: "Café Colonial",
      rating: 5,
      comment: "O CRM integrado nos ajudou a conhecer melhor nossos clientes e criar promoções personalizadas. Fidelização aumentou 30%!",
      date: "Setembro 2024"
    }
  ];

  const features = [
    {
      icon: <FaMobileAlt />,
      title: "Garçom Digital",
      description: "Sistema completo de comandas digitais com tablets para garçons"
    },
    {
      icon: <FaTruck />,
      title: "Delivery Integrado",
      description: "Gestão completa de entregas com rastreamento em tempo real"
    },
    {
      icon: <FaClipboardList />,
      title: "Pedidos na Web",
      description: "Cardápio online para pedidos diretos pelo site ou app"
    },
    {
      icon: <FaUsers />,
      title: "CRM Avançado",
      description: "Gestão completa de clientes com histórico e preferências"
    },
    {
      icon: <FaChartLine />,
      title: "Relatórios Detalhados",
      description: "Analytics completo com insights para crescer seu negócio"
    },
    {
      icon: <FaStore />,
      title: "Multi-unidades",
      description: "Gerencie várias lojas em um único sistema integrado"
    }
  ];


  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(imageInterval);
  }, [images.length]);

  useEffect(() => {
    const testimonialInterval = setInterval(() => {
      setCurrentTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(testimonialInterval);
  }, [testimonials.length]);

  const handleImageIndicatorClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handleTestimonialIndicatorClick = (index) => {
    setCurrentTestimonialIndex(index);
  };

  const renderStars = (rating) => {
    return Array(rating).fill(0).map((_, i) => (
      <FaStar key={i} className={styles.star} />
    ));
  };

  return (
    <div className={styles.container}>
      <PageSEO
        title="Simão — Gestão para Restaurantes e Food Service"
        description="Sistema completo para restaurantes, bares e lanchonetes: garçom digital, delivery integrado, pedidos online, CRM, relatórios e gestão multi-unidades em uma única plataforma."
        path="/Simao"
        lang={lang}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Simão Menu',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web, Android, iOS',
          description: 'Sistema de gestão completo para restaurantes, bares e lanchonetes.',
          url: 'https://steinsoft.com.br/Simao',
        }}
      />
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            <span className={styles.productName}>Simão</span>
            <span className={styles.tagline}>O Futuro do Atendimento Gastronômico</span>
          </h1>
          <p className={styles.subtitle}>
            Sistema completo de gestão para restaurantes, bares e lanchonetes. 
            Garçom digital, delivery integrado, pedidos online e muito mais!
          </p>
          <div className={styles.heroButtons}>
            <button className={styles.primaryButton}>
              Solicitar Demonstração
            </button>
            <button className={styles.secondaryButton}>
              Falar com Especialista
            </button>
          </div>
        </div>
        <div className={styles.heroImage}>
          <img src="/image.png" alt="Simão - Sistema de Gestão" />
        </div>
      </section>

      <section className={styles.features}>
        <h2 className={styles.sectionTitle}>Recursos Principais</h2>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.featureIcon}>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.showcase}>
        <h2 className={styles.sectionTitle}>Transforme seu Atendimento</h2>
        <div className={styles.showcaseContent}>
          <div className={styles.showcaseText}>
            <h3>Solução Completa para Gestão Gastronômica</h3>
            <p>
              O Simão é um sistema inovador que revoluciona a forma como restaurantes, 
              bares e lanchonetes gerenciam seus negócios. Como concorrente direto do 
              Abraão Cardápio, oferecemos uma plataforma moderna e intuitiva que integra 
              todas as operações do seu estabelecimento em um único lugar.
            </p>
            <p>
              Desde o atendimento com tablets para garçons até a gestão completa de 
              delivery e pedidos online, o Simão é a escolha certa para quem busca 
              eficiência, controle e crescimento.
            </p>
            <div className={styles.statsRow}>
              <div className={styles.statItem}>
                <h4>+500</h4>
                <span>Clientes Satisfeitos</span>
              </div>
              <div className={styles.statItem}>
                <h4>+1M</h4>
                <span>Pedidos Processados</span>
              </div>
              <div className={styles.statItem}>
                <h4>99.9%</h4>
                <span>Disponibilidade</span>
              </div>
            </div>
          </div>
          <div className={styles.showcaseImage}>
            <img src="/image.png" alt="Simão em Ação" />
          </div>
        </div>
      </section>

      <section className={styles.carousel}>
        <h2 className={styles.sectionTitle}>Veja o Simão em Ação</h2>
        <div className={styles.carouselContainer}>
          <div className={styles.carouselImages}>
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Simão Screenshot ${index + 1}`}
                className={index === currentImageIndex ? styles.active : ''}
              />
            ))}
          </div>
          <div className={styles.carouselIndicators}>
            {images.map((_, index) => (
              <button
                key={index}
                className={index === currentImageIndex ? styles.active : ''}
                onClick={() => handleImageIndicatorClick(index)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className={styles.testimonials}>
        <h2 className={styles.sectionTitle}>O que nossos clientes dizem</h2>
        <div className={styles.testimonialsContainer}>
          <div className={styles.testimonialCards}>
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`${styles.testimonialCard} ${index === currentTestimonialIndex ? styles.active : ''}`}
              >
                <FaQuoteLeft className={styles.quoteIcon} />
                <p className={styles.testimonialComment}>{testimonial.comment}</p>
                <div className={styles.testimonialFooter}>
                  <div className={styles.testimonialAuthor}>
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.business}</p>
                    <span className={styles.testimonialDate}>{testimonial.date}</span>
                  </div>
                  <div className={styles.testimonialRating}>
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.testimonialIndicators}>
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={index === currentTestimonialIndex ? styles.active : ''}
                onClick={() => handleTestimonialIndicatorClick(index)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className={styles.cta}>
        <div className={styles.ctaContent}>
          <div className={styles.ctaIcon}>
            <FaExternalLinkAlt />
          </div>
          <h2>Conheça todos os recursos do Simão</h2>
          <p>
            Visite nosso site oficial para descobrir como o Simão pode transformar 
            seu estabelecimento. Solicite uma demonstração gratuita e veja na prática 
            todos os benefícios da nossa plataforma.
          </p>
          <div className={styles.ctaButtons}>
            <a 
              href="https://simaomenu.com.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.primaryButton}
            >
              Visitar Site Oficial
              <FaArrowRight />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Simao;